<template>
    <div>


        <v-card outlined
                class="mb-4"
                color="#488ba6"
                dark
        >
            <div v-if="!state.payment.response.error">

                <v-card-title class="headline">Review Order
                </v-card-title>


                <ReviewTable :form-total="formTotal"></ReviewTable>

            </div>

        </v-card>

    </div>
</template>

<script>

    import {mapGetters} from 'vuex'
    import ReviewTable from './ReviewTable'

    export default {
        name: "Review",
        computed: {
            ...mapGetters({
                state: 'getState',
            }),

        },
        props: [
            'formTotal'
        ],
        components: {
            ReviewTable,
        }
    }
</script>

<style scoped>

</style>